/**
 * @private
 */
export default () => {
    const pageTypeService = Shopware.Service().get('cmsPageTypeService');

    pageTypeService.register(
        {
            name: 'cms_blog',
            icon: 'regular-image-text',
            title: 'acris-blogs.cms.pageTypeBlogLayout'
        }
    )
};
